<template>
  <div class="columns">
    <div class="column is-8 is-offset-2 content">
      <article class="box">
        <h1>
          {{ title }}
        </h1>
        <div v-html="$md.render(postDescription)" />
        <div v-if="postMedia">
          <player
            v-if="isVideo(postMedia)"
            :video="getVideo"
          />
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import player from '~/components/video-player'
import { cached } from '~/lib/cache'

const post = gql`
  query blogPosts($slug: String!) {
    post: blogPosts(
      stage: PUBLISHED,
      where: { slug: $slug }
    ) {
      id
      slug
      title
      postDescription
      dateAndTime
      postCoverMedia {
        url
      }
      socialText
      teaserText
      postMedia {
        url
        fileName
        mimeType
      }
    }
  }
`

export default {
  layout: 'static',

  components: {
    player
  },

  data: () => ({}),

  scrollToTop: true,

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          property: 'description',
          content: this.getDescription
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: this.getUrl
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.getImage
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.getDescription
        }
      ]
    }
  },

  async asyncData({ app, route, req, error }) {
    const { data } = await cached(
      `singleBlogPost-${route.params.slug}`,
      app.apolloProvider.clients.blog.query,
      {
        query: post,
        variables: { slug: route.params.slug }
      },
      req
    )

    if (!data || !data.post || !data.post.length) {
      return error({
        message: app.i18n.t('errors.post.notFound'),
        statusCode: 404
      })
    }
    return data.post[0]
  },

  computed: {
    getVideo() {
      return {
        mimeType: this.postMedia.mimeType,
        path: this.postMedia.url
      }
    },
    getImage() {
      if (this.postCoverMedia && this.postCoverMedia.url) {
        return this.postCoverMedia.url
      }
      return ''
    },
    getDescription() {
      if (this.socialText) {
        return `${this.socialText.substr(0, 157)}...`
      }
      return ''
    },
    getUrl() {
      if (this.$i18n.locale === 'de') {
        return `${process.env.API_BASE_URL_CLIENT_DE}${this.$route.path}`
      }
      return `${process.env.API_BASE_URL_CLIENT}${this.$route.path}`
    }
  },

  methods: {
    isVideo(media) {
      return media.mimeType.match('video/*')
    }
  }
}
</script>
